class Smart extends CollectionPanel {

	/**
	 *
	 * @param title
	 * @param id
	 * @param sort
	 */
	constructor(title: string, id?: number | string, sort?: string) {
		super(title);

		this.type = CollectionType.Smart;
		this.sort = sort;

		this.view();
		this.setUpEvents();
		this.getData(id);
	}
}